import ig from '../../assets/images/ig.jpg';

export const igCaption = {
  title: 'Caption Generator',
  description: `Upgrade your Instagram game with captions generated by our
            AI-powered system, taking the hassle out of coming up with
            creative captions.`,
  cta: "Let's Caption",
  image: ig,
  launched: true,
  link: '/captions',
};
